<template>
  <div ref="pageView" class="page-view container-view pd-lr-20">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title
        >接口文档下载中心
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" v-show="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.interfaceIdList" class="form-item_2">
            <el-select
              v-model="slotForms.forms.interfaceIdList"
              multiple
              filterable
              collapse-tags
              reserve-keyword
              placeholder="接口名称"
              :loading="loading"
            >
              <el-option
                v-for="item in interfaceOptAll"
                :key="item.interfaceId"
                :label="item.interfaceName"
                :value="item.interfaceId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格tab -->
    <!-- 表格tab end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
        @selection-change="handleSelectionChange"
        v-loading="tableLoading"
        element-loading-text="拼命加载中"
      >
        <el-table-column
          align="center"
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          label="序号"
          width="50"
          fixed
          type="index"
        ></el-table-column>
        <el-table-column
          label="接口名称"
          fixed
          prop="interfaceName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="接口描述"
          fixed
          prop="interfaceDesc"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="接口类型"
          prop="interfaceType"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <label v-if="scope.row.interfaceType == 1">公共接口</label>
            <label v-if="scope.row.interfaceType == 2">私有接口</label>
          </template>
        </el-table-column>
        <el-table-column
          label="日最大调用次数"
          prop="dayCallNum"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="访问间隔(ms)"
          prop="callSpace"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="更新时间"
          prop="modifiedTime"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          fixed="right"
          :label="$t('_private.button.operate')"
          width="80"
        >
          <template slot-scope="scope">
            <el-button type="text" round @click="DownloadFile(scope.row)"
              >下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
  </div>
</template>

<script>
import {
  FetchByPage,
  FetchInterfaceName,
  DownloadFile
} from "@/api/buttJointCenter/interfaceDocumentCenter";
import { mapGetters } from "vuex";
import resizeListener from "_private/mixins/resizeListener";
import { mergeFormExtend } from "_private/utils/merge";
import operationManage from "_private/mixins/operationManage";

export default {
  mixins: [resizeListener, operationManage],
  data() {
    return {
      total: 0,
      curPage: 1,
      pageSize: 20,
      isSearch: true,
      formExtend: {
        forms: {
          interfaceIdList: []
        },
        extends: []
      },
      tableData: [],
      interfaceOptAll: [], //接口名称全量
      multipleSelection: [],
      messageBoxVisible: false,
      tableLoading: false,
      url: "/app/file/download/"
    };
  },
  computed: {
    ...mapGetters(["moduleId", "userId"]),
    appIds() {
      let ids = this.multipleSelection.map(item => {
        return item.appId;
      });
      return ids.length < 1 ? "" : ids.join(",");
    }
  },
  created() {
    this.FetchByPage(this.mergeObj());
    this.FetchAllInterfaceName();
  },
  methods: {
    // 获取表格数据
    FetchByPage(data) {
      this.tableLoading = true;
      FetchByPage(data)
        .then(response => {
          if (
            response.result &&
            response.result.data &&
            Array.isArray(response.result.data)
          ) {
            this.tableData = response.result.data;
            this.total = response.result.totalRecords;
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    //获取接口名称全量
    FetchAllInterfaceName() {
      FetchInterfaceName()
        .then(res => {
          let list = [];
          if (res.code === 1 && Array.isArray(res.result)) {
            list = res.result;
          }
          this.interfaceOptAll = list;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        moduleId: this.moduleId,
        interfaceIdList: this.formExtend.forms.interfaceIdList,
        pageParamVO: {
          curPage: this.curPage,
          pageSize: this.pageSize
        }
      });
    },
    //下载文件
    DownloadFile(row) {
      DownloadFile({ fileName: row.interfaceDocumentName })
        .then(response => {
          this.exportXlsx(response, `${row.interfaceDocumentName}`);
          this.$message.success("下载成功");
        })
        .catch(error => {
          console.log(error);
        });
      // document.location.href = this.url + row.interfaceDocumentName;
    },
    exportXlsx(data, name) {
      const blob = new Blob([data]);
      const fileName = name; //下载文件名称
      const eLink = document.createElement("a");
      eLink.download = fileName;
      eLink.style.display = "none";
      eLink.href = URL.createObjectURL(blob);
      document.body.appendChild(eLink);
      eLink.click();
      URL.revokeObjectURL(eLink.href); // 释放URL 对象
      document.body.removeChild(eLink);
    },
    submitCallback(data) {
      let type = data.code === 1 ? "success" : "error";
      let message = data.message;
      this.$message({
        showClose: true,
        message: message,
        type: type,
        duration: 2000,
        onClose: () => {
          if (type === "success") {
            this.curPage = 1;
            this.FetchByPage(this.mergeObj());
          }
        }
      });
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },
    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.FetchByPage(this.mergeObj());
    },
    // handleResetForm() {
    //     this.$refs.selectTree.handleclear();
    // },
    // 表格选择改变事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.FetchByPage(this.mergeObj());
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.FetchByPage(this.mergeObj());
    },
    handleResetForm() {
      this.formExtend.forms.appKey = null;
      this.formExtend.forms.userNickName = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}
.title-section {
  padding: 15px 0 10px;
}
.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}
</style>
